import * as React from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';
import {
  Stepper,
  STEPPER_OFFSET_ONBOARDING,
  StepperWrapper,
} from '@hotjar/webapp/features/Registration/components/Stepper';

import { Logo } from './Logo';
import { OnboardingProgressBar } from '../OnboardingProgressBar';
import { isUrlOnboarding, isUrlSetup } from '../OnboardingProgressBar/utils';

const Header = styled.header`
  width: 100%;
  height: 54px;
  min-height: 54px;
  background: ${tokens.color.ui_background};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

interface TopBarProps {
  children?: React.ReactNode;
  className?: string;
}

export const TopBar = ({ children, className }: TopBarProps): JSX.Element => {
  const isProgressBarVisible = isUrlOnboarding() || isUrlSetup();

  return (
    <>
      {isProgressBarVisible ? <OnboardingProgressBar /> : null}
      <Header data-testid="activation-top-bar" className={className}>
        <StepperWrapper offsetLeft={STEPPER_OFFSET_ONBOARDING}>
          <Stepper isOnboarding={isUrlOnboarding()} isSetup={isUrlSetup()} />
        </StepperWrapper>
        <Logo />
        {children}
      </Header>
    </>
  );
};
